import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import RadioSection from "@/components/RadioSection";
import ServiceTabs from "@/components/ServiceTabs";
import Features from "@/components/Features";
import Comparison from "@/components/Comparison";
import WaysToListen from "@/components/WaysToListen";
import Plans from "@/components/Plans";
import PlanComparison from "@/components/PlanComparison";
import Antivirus from "@/components/Antivirus";
import TrustStats from "@/components/TrustStats";
import Testimonials from "@/components/Testimonials";
import FAQ from "@/components/FAQ";
import Newsletter from "@/components/Newsletter";
import Footer from "@/components/Footer";

export default function Landing() {
  return (
    <div className="relative min-h-screen bg-white text-[#0F172A]" data-testid="landing-page">
      <Navbar />
      <Hero />
      <RadioSection />
      <ServiceTabs />
      <Features />
      <Comparison />
      <WaysToListen />
      <Plans />
      <PlanComparison />
      <Antivirus />
      <TrustStats />
      <Testimonials />
      <FAQ />
      <Newsletter />
      <Footer />
    </div>
  );
}
